import { render, staticRenderFns } from "./EditContactDialog.vue?vue&type=template&id=ee83eb08&scoped=true"
import script from "./EditContactDialog.vue?vue&type=script&lang=ts"
export * from "./EditContactDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee83eb08",
  null
  
)

export default component.exports